// Override with REACT_APP_GZIP_MIN_BYTES (e.g. 0 to compress everything while testing).
const MIN_BYTES =
  Number.isFinite(Number(process.env.REACT_APP_GZIP_MIN_BYTES)) &&
  process.env.REACT_APP_GZIP_MIN_BYTES !== undefined &&
  process.env.REACT_APP_GZIP_MIN_BYTES !== ""
    ? Number(process.env.REACT_APP_GZIP_MIN_BYTES)
    : 1024;
const API_ORIGIN = (() => {
  try {
    return new URL(process.env.REACT_APP_BASE_URL).origin;
  } catch {
    return null;
  }
})();
const METHODS = ["post", "put", "patch"];

const isPlainJson = (data) =>
  data !== null &&
  typeof data === "object" &&
  !(data instanceof FormData) &&
  !(data instanceof Blob) &&
  !(data instanceof ArrayBuffer) &&
  !ArrayBuffer.isView(data) &&
  !(data instanceof URLSearchParams);

const targetsApi = (config) => {
  if (!API_ORIGIN) return false;
  try {
    return (
      new URL(config.url, config.baseURL || window.location.origin).origin ===
      API_ORIGIN
    );
  } catch {
    return false;
  }
};

const gzip = async (text) => {
  const stream = new Blob([text])
    .stream()
    .pipeThrough(new CompressionStream("gzip"));
  return new Response(stream).arrayBuffer();
};

export const registerGzipRequestInterceptor = (axiosInstance) => {
  if (
    typeof CompressionStream === "undefined" ||
    process.env.REACT_APP_DISABLE_GZIP_REQUESTS === "true"
  )
    return;

  axiosInstance.interceptors.request.use(async (config) => {
    try {
      if (
        config.skipGzip ||
        !METHODS.includes((config.method || "get").toLowerCase())
      )
        return config;
      if (!targetsApi(config)) return config;
      const headers = config.headers || {};
      if (headers["Content-Encoding"] || headers["content-encoding"])
        return config;

      let json = null;
      if (isPlainJson(config.data)) json = JSON.stringify(config.data);
      else if (
        typeof config.data === "string" &&
        /json/i.test(
          String(headers["Content-Type"] || headers["content-type"] || ""),
        )
      )
        json = config.data;
      if (json === null || json.length < MIN_BYTES) return config;

      const originalBytes = new TextEncoder().encode(json).byteLength;
      config.data = await gzip(json);
      console.log(
        `Gzip: ${originalBytes} -> ${config.data.byteLength} bytes`,
      );

      config.headers["Content-Type"] = "application/json";
      config.headers["Content-Encoding"] = "gzip";
    } catch {
      // Compression is an optimisation only; send the request unchanged on any failure.
    }
    return config;
  });
};
